import apiArticle from '@/api/vo/article';

const defaultState = () => ({
	listArticle: [],
	articlePagination: '',
	listCategory: [],
	categoryPagination: '',
	detailArticle: '',
});

const state = defaultState();

const getters = {};

const mutations = {
	setListArticle(state, data) {
		state.listArticle = data.data;
		state.articlePagination = data.pagination;
	},
	setListCategory(state, data) {
		state.listCategory = data.data;
		state.categoryPagination = data.pagination;
	},
	setDetailArticle(state, data) {
		state.detailArticle = data.data;
	},
};

const actions = {

	getListArticle({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiArticle.getListArticle(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListArticle', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListArticle', []);
			});
		});
	},

	getListArticleByCategory({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiArticle.getListArticleByCategory(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListArticle', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListArticle', []);
				reject()
			});
		});
	},

	getListCategory({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiArticle.getListCategory(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListCategory', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListCategory', []);
				reject()
			});
		});
	},
	
	getDetailArticle({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiArticle.getDetailArticle(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailArticle', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailArticle', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;

				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};